import Vue from "vue";
import VueResource from "vue-resource";
Vue.use(VueResource);

const API_HOST = "https://www.qazlatyn.kz";
const API_LANGUAGE_LIST = "/api/qazlatyn/getlanguagelist";
const API_LANGUAGE_PACK = "/api/qazlatyn/getlanguagepack";

const api = {
  apiHost() {
    return API_HOST;
  },

  getLanguageList(callback) {
    Vue.$http
      .post(API_HOST + API_LANGUAGE_LIST, new FormData())
      .then(result => {
        callback(result);
      });
  },

  getLanguagePack(callback) {
    let fd = new FormData();
    fd.append("language", "this.$route.params.ln");
    Vue.$http.post(API_HOST + API_LANGUAGE_PACK, fd).then(result => {
      callback(result);
    });
  }
};

export default api;
